<template>
    <div  class="historico-beneficiario-painel px-4 pt-4 pb-2"> 
        <div class="title title-primary d-flex">
            <b-dropdown size="lg" toggle-class="text-decoration-none">
                <template #button-content>
                    <DynamicIcon icon="building" classString="container-title-icon mr-2"/>
                    <p class="d-flex align-items-center mt-1 optum-bold font-24px">{{selectedEmpresa}}</p> 
                </template>
                <b-dropdown-item @click="selectEmpresa">Todas as Empresas</b-dropdown-item>
                <b-dropdown-item v-for="empresa in empresaOptions" :key="empresa.value" @click="selectEmpresa(empresa)">
                    {{empresa.text}}
                </b-dropdown-item>
            </b-dropdown>           
        </div>
        <div class="d-flex justify-content-center w-100" v-if="showLoader">
            <b-spinner label="Spinning"/>
        </div>
        <div class="div-bloco-painel row justify-content-between w-100 m-0" >           
            <div class="col-lg-4 col-12" v-for="(bloco, index) in blocoIteravel" :key="index">
                <div class="bloco-painel p-2">
                    <DynamicIcon :icon="bloco.icon" classString="bloco-painel-icon mr-3" />
                    <div class="bloco-painel-info">
                        <p class="bloco-painel-numeral mr-3 optum-bold">{{bloco.numeroAlert}}</p>
                        <p class="bloco-painel-text mr-3 optum-bold ">
                            {{bloco.title}}
                        </p>
                    </div> 
                </div>        
            </div>
        </div>
        <div v-if="lastUpdated" class="last-update w-100 d-flex justify-content-end mt-2">
            Última atualização: {{lastUpdated}}
        </div>    
    </div>
</template>

<script>

import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"
import EmpresaResource from "@/resources/EmpresaResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import DateUtils from "@/util/DateUtils"

export default {
    name: "HistoricoBeneficiarioPainel",
    components: {
        DynamicIcon
    },
    props: {
        refresh: Boolean,
        empresaSelected: Number,
        empresaOptions: Array
    },
    data () { 
        return {
            blocoIteravel: [],
            empresa: null,
            showLoader: true,
            selectedEmpresa: "Todas as empresas",
            lastUpdated: null
        }
    },
    methods: {
        async getTotalTitularesAtivos()
        {
            return {
                icon: "man",
                numeroAlert : await this.getTotal( 1, 1),
                title: "Total de titulares ativos",
            }
        },
        async getTotalDependentesAtivos()
        {
            return {
                icon: "family",
                numeroAlert : await this.getTotal( 2, 1),
                title: "Total de dependentes ativos",
            }
        },
        async getTotalBeneficiariosAtivos ()
        {
            return {
                icon: "group",
                numeroAlert : await this.getTotal( null, 1),
                title: "Total de beneficiários ativos",
            }
        },
        async getTotal( tipo, status)
        {
            try {
                let result = await BeneficiarioImportacaoResource.totalBeneficiario( tipo, status, this.empresa, {showLoader: false})
                
                result = JSON.parse(result)

                if(result.data)
                {
                    return result["data"] || 0
                }

                return result 
                
            } catch (error) {
                return 0
            }
        },
        async calculate()
        {
            Promise.all([
                this.getTotalTitularesAtivos(), 
                this.getTotalDependentesAtivos(), 
                this.getTotalBeneficiariosAtivos()
            ])
            .then((values) => {
                if(Array.isArray(values))
                {
                    this.blocoIteravel = values;
                    this.showLoader = false
                }
            });

            this.refresh = false
        },
        selectEmpresa(empresa){
            if(!empresa.text) {                
                this.selectedEmpresa = "Todas as empresas"
                this.$emit("selectEmpresa")
                return
            }

            this.selectedEmpresa = empresa.text
            this.$emit("selectEmpresa", empresa.value)
            this.getLastImportacao(empresa.value);
        },
        getLastImportacao(empresaId)
        {
            if(empresaId == null)
                return;
            
            return EmpresaResource.getLastImportacao(empresaId, {showLoader: false})
            .then((result) => {
                this.lastUpdated = null
                if(result.lastUpdated) {
                    this.lastUpdated = DateUtils.format(result.lastUpdated)
                }
            })
        }
    },
    watch: {
        refresh: function(newVal){
            if(newVal)
            {
                this.calculate()
            }
        },
        empresaSelected: function(newVal) {
            this.empresa = newVal
            this.calculate()
        },
        empresaOptions: function (newVal)
        {
            if(newVal.length == 1)
                this.selectEmpresa(newVal[0])
        }
    },
    mounted() {
        this.empresa = this.empresaSelected
        this.calculate()
    }
}

</script>

<style lang="scss">
html body .historico-beneficiario-painel .title-primary .b-dropdown .dropdown-toggle{
    background-color: transparent !important;
    border: none;
    display: flex;
    align-items: center;
    color: #002677 !important;
}

html body .historico-beneficiario-painel .title-primary .b-dropdown .optum-bold{
    margin-left: 10px;
}

html body .dropdown-toggle::after{
    margin-top: 5px;
    margin-left: 20px;
}

html body .b-dropdown .dropdown-menu{
    background-color: $screenSecundaryBgColor;
}

html body .b-dropdown .dropdown-menu a:hover{ 
    background-color: $secundaryBgColor;
}

html body .b-dropdown .dropdown-menu a{
    font-family: optum-sans-bold !important;
    color: #002677 !important;
} 


</style>

<style scoped lang="scss">
.historico-beneficiario-painel {
    display: flex;
    flex-direction: column;
    background-color: $screenSecundaryBgColor;
}

.meu-painel{
	height: max-content;
	border-radius: 10px;
	padding: 20px;
	background-color: #fff;
}

html body .meu-painel .title-secondary{
	font-size: 24px !important;
}

.bloco-painel{
    height: 80px;
    background-color: #FFF;
    border: 1px solid #D1D1D1;
    display: flex;
    justify-content: initial;
    align-items: center;
    border-radius: 10px;
}

html body .div-bloco-painel .col-lg-4:nth-child(1){
    padding-right: 6px;
    padding-left: 0px;
}

html body .div-bloco-painel .col-lg-4:nth-child(2){
    padding-left: 3px;
    padding-right: 3px;
}

html body .div-bloco-painel .col-lg-4:nth-child(3){
    padding-left: 6px;
    padding-right: 0px;
}

.bloco-painel-icon{
    width: 50px;
    margin-bottom: 0px !important;
}

.bloco-painel-numeral{
    font-size: 20px;
    font-weight: 600;
    color: $primaryColor;
}

.bloco-painel-text{
    font-size: 16px;
    font-weight: 600;
    color: $tipographyColor;
    text-align: initial;
}

.historico-beneficiario-painel .last-update{
    font-size: 14px;
}

@media (max-width: 1100px) {
    .historico-beneficiario-painel .last-update{
        font-size: 12px;
    }

    .bloco-painel-numeral{
        font-size: 16px;
    }

    .bloco-painel-text{
        font-size: 12px;
    }

    html body .div-bloco-painel .col-lg-4:nth-child(1){
        padding-right: 0px;
        padding-left: 0px;
    }

    html body .div-bloco-painel .col-lg-4:nth-child(2){
        padding: 0px;
        margin: 5px 0px;

    }

    html body .div-bloco-painel .col-lg-4:nth-child(3){
        padding-left: 0px;
        padding-right: 0px;
    }
}
</style>
